var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCIcon = function SvgCIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F5F5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8255 26.216C22.8595 26.216 24.2095 25.568 25.3975 24.524C25.5955 24.344 25.7575 24.074 25.7575 23.732C25.7575 23.174 25.2715 22.706 24.7135 22.706C24.4435 22.706 24.2095 22.814 24.0475 22.958C23.1295 23.732 22.2295 24.164 20.8975 24.164C18.4855 24.164 16.7395 22.166 16.7395 19.7V19.664C16.7395 17.198 18.5035 15.218 20.8975 15.218C22.1035 15.218 23.0395 15.65 23.9035 16.352C24.0475 16.46 24.2635 16.568 24.5695 16.568C25.1815 16.568 25.6675 16.1 25.6675 15.488C25.6675 15.092 25.4695 14.786 25.2355 14.606C24.1375 13.76 22.8595 13.184 20.9155 13.184C17.0995 13.184 14.4175 16.118 14.4175 19.7V19.736C14.4175 23.354 17.1535 26.216 20.8255 26.216Z",
    fill: "#171A20"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/c-icon.436a779371459d50678235a96b6bb950.svg";